import styled from 'styled-components';

export const StyledList = styled.ul`
    max-height: 400px;
    overflow-y: auto;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none;

    > li {
        display: grid;
        grid-template-columns: 1fr 1fr 90px;
        gap: 24px;
        padding: 2px;
        padding-top: 12px;
    }

    > li:not(:last-child) {
        border-bottom: 1px solid var(--gray-4);
        padding-bottom: 4px;
    }
`;
